module.exports = __webpack_public_path__ + "img/1f98b.001d7b0.svg";